const allowedTokenRoutePrefixes = [
  'auth/event',
  'pp/event-public-inspection',
  'pp/event-public-inspection-quotation',
  'pp/event-public-inspection-delivery',
  'pp/event-public-third-party',
  'pp/event-public-driver-monitoring',
  'pp/event-public-quotation',
  'pp/payment-public',
] as const;

const allowedStaticRoutes = [
  'cooperative',
  'regional',
  'voluntario',
  'v4/vistoria',
] as const;

export type WhatsappShareRoutePrefix =
  (typeof allowedTokenRoutePrefixes)[number];
export type WhatsappShareStaticRoute = (typeof allowedStaticRoutes)[number];

const uuidPattern =
  '[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}';
const whatsappShareRoutePattern = new RegExp(
  `^((${allowedTokenRoutePrefixes.join('|')})/${uuidPattern}|${allowedStaticRoutes.join('|')})$`,
  'i',
);

export function getWhatsappShareRoute(search: string): string | null {
  const route = new URLSearchParams(search).get('share');

  return route && whatsappShareRoutePattern.test(route) ? route : null;
}

export function buildWhatsappShareUrl(
  route: WhatsappShareRoutePrefix | WhatsappShareStaticRoute,
  token?: string,
  baseUrl = `${window.location.origin}${window.location.pathname}`,
): string {
  const url = new URL(baseUrl);
  const destination = token ? `${route}/${token}` : route;

  url.searchParams.set('share', destination);
  url.hash = '';

  return url.toString();
}
